<template>
  <b-modal
    v-model="trigger"
    :id="id"
    :ok-title="okTitle"
    :title="title"
    @ok="eventOk($event)"
    @cancel="eventCancel($event)"
    :centered="centered"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :ok-only="okOnly"
    :hide-footer="true"
    :hide-header="true"
  >
    <div class="empanel-modal-close">
      <span v-if="!edit" class="Modal-head-text">Add {{description}}</span>
      <span v-else class="Modal-head-text">Edit {{description}}</span>
      <p class>
        <img
          @click="closeEmpanelModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="card popup-card">
      <!-- adding new card -->
      <div v-if="edit == false">
        <!-- Question  -->
        <div v-if="questions.addRowSavedAnswer==null">
          <div class="custom-card mt-2">
            <span class v-for="(answer,index2) in questions.answerResponse" :key="index2">
              <div class="col-10 ml-4">
                <span v-if="answer.controlType == 'T'">
                  <w-input-text
                    :labelName="answer.displayName"
                    :inputId="answer.keyCode"
                    :inputPlaceholder="''"
                    :defaultValue="''"
                    :validation="fieldValidation(questions,answer)"
                    class="margin-bottom custom-field-size text-left"
                    @textInputChange="getTextFieldValue($event,answer,questions)"
                    :inputType="'text'"
                    :errorMessage="answer.displayName"
                  />
                </span>
                <span v-if="answer.controlType == 'U'">
                  <w-attachment
                    :heading="answer.displayName"
                    class="text-left"
                    :id="'index'+index"
                    @fileInputChange="getAttachmentDocument($event,questions,answer)"
                    :uploadedFiles="attachedFiles"
                  />
                  <span class="mt-5" v-for="(attachedFile,index) in attachedFiles" :key="index">
                    <div>
                      <ul style="list-style-type:square;">
                        <li>
                          <a
                            class="pl-1"
                            @click="showAttachFile(attachedFile)"
                            href="#"
                          >{{getAttachmentName(attachedFile)}}</a>
                        </li>
                      </ul>
                    </div>
                  </span>
                </span>
                <span v-if="answer.controlType == 'DP'">
                  <w-date-picker
                    :inputLabel="answer.displayName"
                    :inputPlaceholder="$t('select date')"
                    :errorMessage="''"
                    :dateRange="''"
                    @inputChange="getDateValue($event,answer,questions)"
                    :defaultValue="''"
                    :v-validate="''"
                    :style="questions.answerResponse.length > 1 ? '':'width:25%'"
                    :currentIndex="0"
                  />
                </span>
              </div>
            </span>
          </div>
        </div>
        <div v-if="questions.addRowSavedAnswer!=null">
          <div class="custom-card" v-for="(answer,index) in questions.answerResponse" :key="index">
            <span v-if="answer.keyDesc == 'Yes'">
              <span v-for="(additionalQuestion,index2) in answer.additionalQuestions" :key="index2">
                <!-- <div class="row ml-4 mt-5"> -->
                <span
                  v-for="(additionalAnswer,index3) in additionalQuestion.additionalAnswerResponse"
                  :key="index3"
                >
                  <div class="col-10 mt-4 ml-3">
                    <span v-if="additionalAnswer.controlType == 'T'">
                      <w-input-text
                        :labelName="additionalAnswer.displayName"
                        :inputId="additionalAnswer.keyCode"
                        :inputPlaceholder="''"
                        :defaultValue="''"
                        :validation="fieldValidation(additionalQuestion,additionalAnswer) "
                        class="margin-bottom custom-field-size text-left"
                        @textInputChange="getTextFieldValue($event,additionalAnswer,additionalQuestion)"
                        :inputType="'text'"
                        :errorMessage="additionalAnswer.displayName"
                      />
                    </span>
                    <span v-if="additionalAnswer.controlType == 'DP'">
                      <w-date-picker
                        :inputLabel="additionalAnswer.displayName"
                        :inputPlaceholder="$t('select date')"
                        :errorMessage="''"
                        :dateRange="''"
                        class="margin-bottom custom-field-size text-left"
                        @inputChange="getDateValue($event,additionalAnswer,additionalQuestion)"
                        :defaultValue="''"
                        :v-validate="''"
                        :currentIndex="0"
                      />
                    </span>
                  </div>
                  <div class="col-10 mt-n3 ml-3">
                    <span v-if="additionalAnswer.controlType == 'U'">
                      <w-attachment
                        :heading="additionalAnswer.displayName"
                        class="text-left"
                        :id="'index'+index"
                        @fileInputChange="getAttachmentDocument($event,questions,additionalAnswer)"
                        :uploadedFiles="''"
                      />
                      <span class="mt-5" v-for="(attachedFile,index) in attachedFiles" :key="index">
                        <div>
                          <ul style="list-style-type:square;">
                            <li>
                              <a
                                class="pl-1"
                                @click="showAttachFile(attachedFile)"
                                href="#"
                              >{{getAttachmentName(attachedFile)}}</a>
                            </li>
                          </ul>
                        </div>
                      </span>
                    </span>
                  </div>
                </span>
                <!-- </div> -->
              </span>
            </span>
          </div>
        </div>
        <div class="row mt-3 mr-1">
          <div class="col">
            <b-button
              class="ml-2 button-class"
              @click="save(questions,editAnswer,edit, 'save')"
              :disabled="disableSaveButton(questions)"
            >Save</b-button>
            <!-- disableSaveButton(questions) -->
          </div>
        </div>
      </div>
      <div v-if="edit == true">
        <div v-if="questions.addRowSavedAnswer==null">
          <div class="custom-card mt-2">
            <span class v-for="(answer,index2) in questions.answerResponse" :key="index2">
              <div class="col-10 ml-4">
                <span v-if="answer.controlType == 'T'">
                  <w-input-text
                    :labelName="answer.displayName"
                    :inputId="answer.keyCode"
                    :inputPlaceholder="''"
                    :defaultValue="getDefaultValue(answer,editAnswer)"
                    :validation="fieldValidation(questions,answer) "
                    class="margin-bottom custom-field-size text-left"
                    @textInputChange="getTextFieldValue($event,answer,questions)"
                    :inputType="'text'"
                    :errorMessage="answer.displayName"
                  />
                </span>
                <span v-if="answer.controlType == 'U'">
                  <w-attachment
                    :heading="answer.displayName"
                    class="text-left"
                    :id="'index'+index"
                    @fileInputChange="getAttachmentDocument($event,questions,answer)"
                    :uploadedFiles="''"
                  />
                  <span class="mt-5" v-for="(attachedFile,index) in attachedFiles" :key="index">
                    <div>
                      <ul style="list-style-type:square;">
                        <li>
                          <a
                            class="pl-1"
                            @click="showAttachFile(attachedFile)"
                            href="#"
                          >{{getAttachmentName(attachedFile)}}</a>
                        </li>
                      </ul>
                    </div>
                  </span>
                </span>
                <span v-if="answer.controlType == 'DP'">
                  <w-date-picker
                    :inputLabel="answer.displayName"
                    :inputPlaceholder="$t('select date')"
                    :errorMessage="''"
                    :dateRange="''"
                    @inputChange="getDateValue($event,answer,questions)"
                    :defaultValue="getDefaultValue(answer,editAnswer)"
                    :v-validate="''"
                    :style="questions.answerResponse.length > 1 ? '':'width:25%'"
                    :currentIndex="0"
                  />
                </span>
              </div>
            </span>
          </div>
        </div>
        <div v-if="questions.addRowSavedAnswer!=null">
          <div class="custom-card" v-for="(answer,index) in questions.answerResponse" :key="index">
            <span v-if="answer.keyDesc == 'Yes'">
              <span v-for="(additionalQuestion,index2) in answer.additionalQuestions" :key="index2">
                <!-- <div class="row ml-4 mt-5"> -->
                <span
                  v-for="(additionalAnswer,index3) in additionalQuestion.additionalAnswerResponse"
                  :key="index3"
                >
                  <div class="col-10 mt-4 ml-3">
                    <span v-if="additionalAnswer.controlType == 'T'">
                      <w-input-text
                        :labelName="additionalAnswer.displayName"
                        :inputId="additionalAnswer.keyCode"
                        :inputPlaceholder="''"
                        :defaultValue="getDefaultValue(additionalAnswer,editAnswer)"
                        :validation="fieldValidation(questions,additionalAnswer) "
                        class="margin-bottom custom-field-size text-left"
                        @textInputChange="getTextFieldValue($event,additionalAnswer,questions)"
                        :inputType="'text'"
                        :errorMessage="additionalAnswer.displayName"
                      />
                    </span>
                  </div>
                  <div class="col-10 mt-n3 ml-3">
                    <span v-if="additionalAnswer.controlType == 'U'">
                      <w-attachment
                        :heading="additionalAnswer.displayName"
                        class="text-left"
                        :id="'index'+index"
                        @fileInputChange="getAttachmentDocument($event,questions,additionalAnswer)"
                        :uploadedFiles="''"
                      />
                      <span class="mt-5" v-for="(attachedFile,index) in attachedFiles" :key="index">
                        <div>
                          <ul style="list-style-type:square;">
                            <li>
                              <a
                                class="pl-1"
                                @click="showAttachFile(attachedFile)"
                                href="#"
                              >{{getAttachmentName(attachedFile)}}</a>
                            </li>
                          </ul>
                        </div>
                      </span>
                    </span>
                  </div>
                  <div class="col-10 ml-3">
                    <span v-if="additionalAnswer.controlType == 'DP'">
                      <w-date-picker
                        :inputLabel="additionalAnswer.displayName"
                        :inputPlaceholder="$t('select date')"
                        :errorMessage="''"
                        :dateRange="''"
                        @inputChange="getDateValue($event,additionalAnswer,questions)"
                        :defaultValue="getDefaultValue(additionalAnswer,editAnswer)"
                        :v-validate="''"
                        :style="questions.answerResponse.length > 1 ? '':'width:25%'"
                        :currentIndex="0"
                      />
                    </span>
                  </div>
                </span>
                <!-- </div> -->
              </span>
            </span>
          </div>
        </div>
        <div class="row mt-3 mr-1">
          <!-- <div class="col-8"></div> -->
          <div class="col">
            <b-button
              class="ml-2 button-class"
              @click="save(questions,editAnswer,edit,'update')"
              :disabled="disableSaveButton(questions)"
            >Update</b-button>
          </div>
        </div>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>
<script>
import axios from "axios";
import CustomTextInput from "../widgets/CustomTextInput";
import attachmentDyanmic from "../widgets/AttachmentDyanmic";
import DatePicker from "../widgets/DynamicDatePicker";
import { OnBoardingServices } from "../services/onBoardingService";
import loadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
import { PartnerService } from "../services/partnerService";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
export default {
  components: {
    "w-input-text": CustomTextInput,
    "w-attachment": attachmentDyanmic,
    "w-date-picker": DatePicker,
    "w-loadingSpinner": loadingSpinner,
    widgetModal
  },
  props: [
    "trigger",
    "text",
    "title",
    "centered",
    "dontCloseWhenClickedOutside",
    "dontCloseWhenEscapePressed",
    "dontShowCloseIcon",
    "modalbuttonStyle",
    "showAlert",
    "showSuccess",
    "questions",
    "edit",
    "editAnswer",
    "description",
    "categoryCode",
    "docNumber"
  ],

  data() {
    return {
      saveRequest: [],
      typedValue: new Map(),
      attachedFiles: [],
      loading: false,
      errorFieldEmpty: false,
      companyCode: "",
      isEditTextSet: false,
      isEditDateSet: false
    };
  },
  created() {
    this.getPartnerInfo();
    if (this.edit == false) {
      this.typedValue = new Map();
    }
    if (this.edit == true) {
      this.editAnswer.forEach(element => {
        this.typedValue.set(element.id.keyCode, element.keyValue);
        if (element.controlType == "U") {
          this.attachedFiles.push(element.keyValue);
        }
      });
    }
  },
  methods: {
    getPartnerInfo() {
      partnerService.getPartnerInfo().then(resp => {
        this.companyCode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
        // this.categoryCode = resp.response.currentCategoryCode;
      });
    },
    disableSaveButton(question) {
      console.log("disableSaveButton", this.typedValue);
      let answerLength;
      if (question.addRowSavedAnswer != null) {
        if (
          question.addRowSavedAnswer &&
          question.addRowSavedAnswer.length > 0
        ) {
          question.addRowSavedAnswer.forEach(element => {
            if (element.length > 0) {
              answerLength = element.length;
            }
          });
        }
      } else {
        if (question.savedAnswer && question.savedAnswer.length > 0) {
          question.savedAnswer.forEach(element => {
            if (element.length > 0) {
              answerLength = element.length;
            }
          });
        }
      }
      if (
        answerLength != this.typedValue.size ||
        this.errors.items.length > 0
      ) {
        return true;
      } else {
        // if (this.typedValue) {
        //   for (let [key, value] of this.typedValue) {
        //     if(value == ''){
        //       return true;
        //     }
        //     // console.log(key, value);
        //   }
        // }
        return false;
      }
    },
    eventOk(event) {
      this.$emit("eventOk", event);
    },
    closeEmpanelModal(event) {
      this.$emit("eventClose", event);
      this.attachedFiles = [];
      this.typedValue = new Map();
    },
    fieldValidation(question, group) {
      let validRegExp = "";
      let requiredExp = "";
      let regexNumber = "";
      let regularExp = "";
      // let validation = group.regularExpression ? group.regularExpression : "";
      if (group && group.inputType == "number") {
        regexNumber = "|regex_number";
        // validRegExp = regexNumber;
      }
      switch (group.regularExpression) {
        case "M":
          regularExp = "|regex_mobile_number";
          break;
        case "E":
          regularExp = "|email";
          break;
        case "A":
          regularExp = "|regex_alpha_special";
          break;
        case "AC":
          regularExp = "|regex_alphacaps";
          break;
        case "AS":
          regularExp = "|alpha_spaces";
          break;
        case "N":
          regularExp = "|regex_number";
          break;
        case "N33":
          regularExp = "|regex_numless33";
          break;
        case "AN":
          regularExp = "|regex_alpha_numeric_space";
          break;
        case "P":
          regularExp = "|regex_percentage";
          break;
        case "PD":
          regularExp = "|regex_percentage_decimal";
          break;
        case "ASC":
          regularExp = "|regex_alpha_special";
          break;
        case "UCY":
          regularExp = "|regex_year";
          break;
        case "PN":
          regularExp = "|regex_negnumber";
          break;
        case "ANS":
          regularExp = "|regex_alpha_numeric_special";
          break;
        default:
          regularExp = "|regex_alpha_numeric_special";
      }
      validRegExp =
        group && group.numberOfDigit ? "|max:" + group.numberOfDigit : "";
      if (question.mandatory == "Y") {
        requiredExp = "required";
        let validated = requiredExp + validRegExp + regexNumber + regularExp;
        validated = validated.replace(/"/g, "'");
        console.log("validated", validated);
        return validated;
      } else {
        let notMandatoryValidated = validRegExp + regexNumber + regularExp;
        notMandatoryValidated = notMandatoryValidated.replace(/"/g, "'");
        console.log("notMandatoryValidated", notMandatoryValidated);
        return notMandatoryValidated;
      }
    },
    getTextFieldValue(event, answer, question) {
      this.typedValue.set(answer.keyCode, event);
      console.log("map", this.typedValue);
    },
    getAttachmentDocument(event, question, answer) {
      this.loading = true;
      let fileList = event;
      // this.attachedFiles = [];
      for (let i = 0; i < fileList.length; i++) {
        let data = new FormData();
        data.append("file", fileList[i]);
        this.loading = true;
        // this.attachedFiles.push(fileList[i]);
        OnBoardingService.uploadAttachments(data)
          .then(res => {
            this.loading = false;
            if (res) {
              console.log("After uploading", this.typedValue);
              this.typedValue.set(answer.keyCode, res.UniqueID);
              console.log("After uploading", this.typedValue);
              this.attachedFiles = [];
              this.attachedFiles.push(res.UniqueID);
              // console.log(this.typedValue);
            }
          })
          .catch(e => {
            this.loading = false;
                window.alert("Something went wrong! try again later");
            console.error(e);
          });
      }
    },
    getDateValue(event, answer, question) {
      this.typedValue.set(answer.keyCode, event);
      console.log("map", this.typedValue);
    },
    getDefaultDateValue(answer, question) {
      let date = "";
      if (question.savedAnswer && question.savedAnswer.length > 0) {
        question.savedAnswer.forEach(element => {
          if (
            element.id &&
            element.id.keyCode == answer.keyCode &&
            element.id.slno == 1
          ) {
            date = element.keyValue;
          }
        });
      }
      return date;
    },
    getDefaultValue(answer, editAnswer) {
      console.log("getDefaultValue", answer, editAnswer);
      let data = "";
      if (editAnswer.length > 0) {
        editAnswer.forEach(element => {
          if (answer.keyCode == element.id.keyCode) {
            // this.typedValue.set(element.id.keyCode, element.keyValue);
            data = element.keyValue;
          }
        });
      }
      console.log("previous value", data);
      return data;
    },
    getUploadedFiles(answer, editAnswer) {},
    // Saving API is done here.
    save(question, editAnswer, edit, action) {
      this.loading = true;
      var docNum = ""
      if(action == "update"){
        docNum = editAnswer[0].id.answerNumber
      }
      console.log("save is called..", question);
      let savedAnswerResponse = {
        categoryCode: this.categoryCode,
        companyCode: this.companyCode,
        moduleCode: "",
        questionCode: "",
        answerType: "",
        answerCode: "",
        keySlNo: "",
        answers: [],
        documentNumber:docNum
      };
      if (editAnswer.length > 0 && edit == true) {
        console.log("Edit is clicked", editAnswer);
        editAnswer.forEach(element => {
          savedAnswerResponse.keySlNo = element.id.slno;
        });
      }
      savedAnswerResponse.answers = this.mapToObject(this.typedValue);
      let answerLength;
      if (question.addRowSavedAnswer != null) {
        savedAnswerResponse.answerType = "S";
        console.log("element", question.addRowSavedAnswer);
        question.addRowSavedAnswer.forEach(element => {
          if (element.length > 0) {
            answerLength = element.length;
            console.log("element.length", element);
            // savedAnswerResponse.answerNumber = element[0].id.answerNumber;
            savedAnswerResponse.moduleCode = element[0].id.moduleCode;
            savedAnswerResponse.questionCode = element[0].id.questionCode;
            savedAnswerResponse.answerCode = element[0].id.answerCode;
          }
        });
        if (answerLength != this.typedValue.size) {
          console.log(
            "answerLength",
            answerLength,
            "savedAnswerResponse.length",
            this.typedValue.size
          );
          console.log("savedAnswerResponse", savedAnswerResponse.answers);
          // alert("fill all details.");
        } else {
          if (this.checkAllFilledFields() == true) {
            console.log("savedAnswerResponse", savedAnswerResponse);
            partnerService
              .quickLinkDraft(savedAnswerResponse)
              .then(res => {
                this.loading = false;
            if (res.failureMessage) {
              this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            } else {
                // this.typedValue = new Map();
                // this.attachedFiles = [];
                this.closeEmpanelModal();
                console.log("after saving", this.typedValue);
                console.log("emiting is happening.");
                this.$emit("afterSave");
            }
              })
              .catch(e => {
                this.loading = false;
                this.closeEmpanelModal();
                window.alert("Something went wrong! try again later");
                //this.$emit("afterSave");
                console.log(e);
              });
          }
        }
      }
      if (question.addRowSavedAnswer == null) {
        savedAnswerResponse.answerType = "R";
        let answerLength;
        question.savedAnswer.forEach(element => {
          if (element.length > 0) {
            answerLength = element.length;
            // savedAnswerResponse.answerNumber = element[0].id.answerNumber;
            savedAnswerResponse.moduleCode = element[0].id.moduleCode;
            savedAnswerResponse.questionCode = element[0].id.questionCode;
            savedAnswerResponse.answerCode = element[0].id.answerCode;
          }
        });
        if (answerLength != this.typedValue.size) {
          console.log(
            "answerLength",
            answerLength,
            "savedAnswerResponse.length",
            this.typedValue.size
          );
          console.log("savedAnswerResponse", savedAnswerResponse.answers);
          // alert("fill all details.");
        } else {
          if (this.checkAllFilledFields() == true) {
            console.log("savedAnswerResponse", savedAnswerResponse);
            partnerService
              .quickLinkDraft(savedAnswerResponse)
              .then(res => {
                this.loading = false;
            if (res.failureMessage) {
              this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            } else {
                this.closeEmpanelModal();
                console.log("after saving", this.typedValue);
                console.log("emiting is happening.");
                this.$emit("afterSave");
            }
              })
              .catch(e => {
                this.loading = false;
                this.closeEmpanelModal();
                console.log("value:", this.typedValue);
                window.alert("Something went wrong! try again later");
                //this.$emit("afterSave");
                console.log(e);
              });
          }
        }
      }
    },
    checkAllFilledFields() {
      for (let value of this.typedValue.values()) {
        if (value.length == 0) {
          this.errorFieldEmpty = true;
          // alert("fill all details.");
          return false;
        }
      }
      return true;
    },
    mapToObject(mappedAnswer) {
      let obj = Object.create(null);
      for (let [k, v] of mappedAnswer) {
        obj[k] = v; //look out! Key must be a string!
      }
      return obj;
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },
    getAttachmentName(attachmentObject) {
      let attachmentName = "";
      attachmentName = attachmentObject.split(/_(.+)/)[1];
      // if (attachmentObject != null) {
      //   attachmentName = attachmentObject.split(/_(.+)/)[1]
      //     ? attachmentObject.split(/_(.+)/)[1]
      //     : attachmentObject;
      // }
      return attachmentName;
    }
  }
};
</script>

<style scoped>
.Modal-head-text {
  color: white;
  font-size: 13px;
  float: left;
}
.approve-tick-image {
  /* width: 23%; */
  height: 8vh !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.Approver-Success-text {
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #333333;
}
.modal-horizontal-line {
  margin-left: 0px;
  margin-right: 0px;
}
.modal-content {
  width: 900px;
  max-height: 300px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.Document-Number {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #777777;
}
.button-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  background-color: #1579ab;
  margin-bottom: 30px;
  margin-left: auto !important;
  margin-right: auto !important;
  display: block;
}
.button-class:disabled {
  color: white !important;
}
.modal-body {
  padding: 0;
}
.modal-close-button {
  border: solid 1px #707070;
  color: rgba(0, 0, 0, 0.85);
  border-radius: 50%;
  background-color: rgb(255, 255, 255) !important;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
}
.nav-link {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  color: #0e5d84;
}
.custom-card {
  margin-left: 10% !important;
}
</style>
